import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    n: 1, title: "Tentang Layanan",
    blocks: [{ p: "Studio Kreator adalah aplikasi asisten kreatif berbasis AI yang membantu content creator dalam membangun personal brand, brainstorming ide, menyusun script, mengubah ulang konten (recreate), merancang strategi funnel konversi, dan menjadwalkan konten. Layanan disediakan oleh PT. Studio Kreator Indonesia." }],
  },
  {
    n: 2, title: "Akun Pengguna",
    blocks: [{ ul: [
      "Anda wajib mendaftar dan membuat akun untuk menggunakan Studio Kreator.",
      "Anda bertanggung jawab menjaga kerahasiaan kata sandi akun Anda dan seluruh aktivitas yang terjadi di bawah akun Anda.",
      "Anda wajib memberikan informasi yang akurat saat mendaftar.",
    ] }],
  },
  {
    n: 3, title: "Langganan dan Pembayaran",
    blocks: [{ ul: [
      "Studio Kreator beroperasi dengan model langganan berbayar. Seluruh fitur hanya dapat diakses setelah Anda memiliki langganan aktif.",
      "Tersedia dua paket: **Bulanan** (Rp55.000/bulan) dan **Tahunan** (Rp550.000/tahun).",
      "Pembayaran diproses melalui mitra pemroses pembayaran pihak ketiga (Paywuz), mendukung QRIS dan Virtual Account.",
      "Langganan akan otomatis berakhir pada tanggal jatuh tempo kecuali Anda memperpanjangnya. Studio Kreator saat ini **tidak menerapkan perpanjangan otomatis (auto-renewal)** — Anda perlu memperpanjang secara manual melalui halaman Kelola Langganan.",
      "Anda dapat berhenti berlangganan kapan saja; penghentian tidak memengaruhi masa aktif langganan yang sudah dibayar hingga tanggal berakhirnya.",
    ] }],
  },
  {
    n: 4, title: "Kebijakan Refund",
    blocks: [{ ul: [
      "Pembayaran langganan yang telah berhasil diproses **tidak dapat dikembalikan (non-refundable)**, kecuali dalam kasus kesalahan teknis dari pihak kami (misalnya biaya terpotong dua kali untuk satu transaksi, atau akses gagal terbuka setelah pembayaran berhasil dikonfirmasi).",
      "Jika Anda mengalami masalah pembayaran, silakan hubungi kami di halo@studiokreator.id dengan menyertakan bukti transaksi, dan kami akan menindaklanjuti dalam waktu maksimal 3 hari kerja.",
    ] }],
  },
  {
    n: 5, title: "Penggunaan yang Diperbolehkan",
    blocks: [
      { p: "Anda setuju untuk menggunakan Studio Kreator secara wajar dan tidak:" },
      { ul: [
        "Menyalahgunakan layanan untuk menghasilkan konten yang melanggar hukum, menyesatkan, atau merugikan pihak lain",
        "Mencoba mengakses, meretas, atau mengganggu sistem kami",
        "Membagikan akun Anda kepada pihak lain untuk penggunaan komersial tanpa izin dari kami",
      ] },
      { p: "Kami berhak menangguhkan atau menghentikan akun yang melanggar ketentuan ini tanpa pemberitahuan sebelumnya." },
    ],
  },
  {
    n: 6, title: "Kepemilikan Konten",
    blocks: [{ ul: [
      "Konten (script, ide, hasil generate) yang dihasilkan melalui akun Anda menjadi milik Anda sepenuhnya untuk digunakan sesuai keperluan Anda.",
      "Kami tidak mengklaim hak cipta atas konten yang Anda hasilkan menggunakan Studio Kreator.",
      "Anda tetap bertanggung jawab penuh atas penggunaan dan publikasi konten yang dihasilkan, termasuk memastikan konten tersebut tidak melanggar hak pihak ketiga.",
    ] }],
  },
  {
    n: 7, title: "Batasan Tanggung Jawab",
    blocks: [{ ul: [
      "Studio Kreator adalah alat bantu kreatif berbasis AI. Kami tidak menjamin bahwa hasil yang dihasilkan akan selalu akurat, bebas kesalahan, atau menghasilkan performa konten tertentu (views, engagement, penjualan, dll).",
      "Kami tidak bertanggung jawab atas kerugian yang timbul dari penggunaan konten yang dihasilkan oleh layanan kami.",
      "Layanan disediakan \"sebagaimana adanya\" tanpa jaminan ketersediaan 100% tanpa gangguan.",
    ] }],
  },
  {
    n: 8, title: "Perubahan Layanan dan Harga",
    blocks: [{ p: "Kami berhak mengubah fitur, harga, atau ketentuan layanan dari waktu ke waktu. Perubahan harga tidak akan memengaruhi langganan yang sudah aktif hingga masa berlakunya berakhir; perubahan akan berlaku untuk perpanjangan atau langganan baru." }],
  },
  {
    n: 9, title: "Penghentian Layanan",
    blocks: [{ p: "Kami berhak menghentikan atau menangguhkan akses Anda ke layanan jika ditemukan pelanggaran terhadap syarat layanan ini, tanpa kewajiban pengembalian dana atas sisa masa langganan yang belum digunakan." }],
  },
  {
    n: 10, title: "Perubahan Ketentuan",
    blocks: [{ p: "Kami dapat memperbarui Syarat Layanan ini dari waktu ke waktu. Perubahan signifikan akan diinformasikan melalui email atau pemberitahuan di dalam aplikasi." }],
  },
  {
    n: 11, title: "Kontak",
    blocks: [
      { p: "Untuk pertanyaan seputar Syarat Layanan ini, silakan hubungi:" },
      { p: "**Email:** halo@studiokreator.id" },
    ],
  },
];

export default function SyaratLayanan() {
  return <LegalLayout title="Syarat Layanan" lastUpdated="1 September 2026" sections={SECTIONS} />;
}
